import { render, staticRenderFns } from "./lk-course-content.vue?vue&type=template&id=05f8b722&"
import script from "./lk-course-content.vue?vue&type=script&lang=js&"
export * from "./lk-course-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-course/lk-course-content/lk-course-content.vue
// module id = 1204
// module chunks = 0